import React, { useEffect, useState } from "react";
import { Notifications } from "./Notifications";
import { deleteNotificationService, getNotificationsService, readNotificationService } from "../../../services/services";
import { useKeycloak } from "@react-keycloak/web";
import { MULTITENANT_CONSTANTS, TENANT } from "../../../Resources/Multitenant/tenantConstants";
import {getToken} from "../../../Utils/utils";
import { useDispatch } from "react-redux";
import { saveNotificationsActionCreator } from "../../../actions/commonActions";
import { useSelector } from "react-redux";

export function NotificationsProvider(props) {
  const [notificationsData, setNotificationsData] = useState(null);
  const { notifications } = useSelector((state) => state.commonState);

  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();
  const username = keycloak?.tokenParsed?.preferred_username;
  const userToken = getToken(keycloak);


  const reloadNotifications = () => {
    getNotificationsServiceWrapper();
  };

  const getNotificationsCallback = (data) => {
    const updatedNotifications = data.notifications
      .filter(notification => notification.status !== "deleted")
      .map(notification =>
        notification.read_on === null
          ? { ...notification, isNew: true }
          : { ...notification }
      )
      .reverse();

    setNotificationsData(updatedNotifications);
    dispatch(saveNotificationsActionCreator(true));
  };

  const getNotificationsServiceWrapper = () => {
    !!username &&
    getNotificationsService(MULTITENANT_CONSTANTS[TENANT].tenantServer, username, userToken, getNotificationsCallback)
  }

  useEffect(() => {
    if (notifications === undefined) {
      getNotificationsServiceWrapper();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications]);

  const deleteNotification = (id) => {
    deleteNotificationService(MULTITENANT_CONSTANTS[TENANT].tenantServer, id, userToken, getNotificationsServiceWrapper)
  };

  const readNotification = (id) => {
    readNotificationService(MULTITENANT_CONSTANTS[TENANT].tenantServer, id, userToken, getNotificationsServiceWrapper)
  };

  const { children } = props;

  return (
    <Notifications.Provider
      value={{
        notifications: notificationsData,
        reloadNotifications: reloadNotifications,
        deleteNotification: deleteNotification,
        readNotification: readNotification,
      }}
    >
      {children}
    </Notifications.Provider>
  );
}
